import { AwardNominationReviewer } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardNominationReviewers: (
  fetchContext: FetchContext,
  awardId: number,
  accessToken?: string,
) => Promise<AwardNominationReviewer[]> = (fetchContext, awardId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/nomination-reviewers`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<AwardNominationReviewer[]>(fetchContext.errorStore, response, 'get award nomination reviewers'));
